import { HashRouter, Switch, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AuthProvider } from './contexts/AuthContext';

import { getURL } from './components/App/AppxUtils';

import SignUpRequest from './modules/SignUpRequest';
import SignUpRequestView from './modules/SignUpRequest/view';
import SignUpRequestOngoing from './modules/SignUpRequest/ongoing';
import Zone from './modules/Plan/zone';
import Plan from './modules/Plan';
import PageNotFound from './modules/PageNotFound';

import { THEMES } from './theme';
import { ORGS } from './config';


function App() {
    const { i18n } = useTranslation("appxweb");
    let url = getURL();
    let org = "fa";

    if (url?.pathname) {
        let pathname = url.pathname
            .split("/")
            .map(r => r.trim())
            .filter(r => r !== "");

        for (let o of pathname) {
            if (undefined !== THEMES[o]) {
                org = o;
                break;
            }
        }
    }

    if (undefined === THEMES[org]) {
        throw new Error('Theme does not found!');
    }

    const themeOrg = THEMES[org];

    if (undefined === themeOrg.config) {
        throw new Error('Theme config is mandatory!');
    }

    if (undefined === themeOrg.config.en) {
        throw new Error('English config is mandatory!');
    }

    const themeOrgConfig = themeOrg.config?.[i18n.language]
        ? themeOrg.config[i18n.language]
        : themeOrg.config.en;
    // Set Favicon
    document.querySelector('link[rel="icon"]').href = THEMES[org].favicon;

    return (
        <AuthProvider
            org={org}
            theme={themeOrg.name}
            themeConfig={themeOrgConfig}
            config={ORGS[org]}
        >
            <HashRouter basename={org}>
                <Switch>
                    <Route path="/" exact>
                        <SignUpRequest />
                    </Route>
                    <Route path="/view/:modelId" exact>
                        <SignUpRequestView />
                    </Route>
                    <Route path="/ongoing/:modelId" exact>
                        <SignUpRequestOngoing />
                    </Route>
                    <Route path="/plans" exact>
                        <Plan />
                    </Route>
                    <Route path="/zone-plans" exact>
                        <Zone />
                    </Route>
                    <Route path="*">
                        <PageNotFound />
                    </Route>
                </Switch>
            </HashRouter>
        </AuthProvider>
    );
}

export default App;
